<template>
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><path d="M25.185 36.666H2.222a12.645 12.645 0 0 1 8.941-3.703h14.022a4.062 4.062 0 0 0 4.074-4.074V18.148h3.703v10.74a7.777 7.777 0 0 1-7.777 7.778Z" fill="url(#paint0_linear_221_5669)" stroke="transparent"></path><path d="M5.555 29.63H1.852V11.84c0-4.29 3.481-7.766 7.777-7.766h20a12.649 12.649 0 0 1-8.937 3.699H9.629a4.06 4.06 0 0 0-4.074 4.068V29.63Z" fill="url(#paint1_linear_221_5669)" stroke="transparent"></path><path d="M19.444 29.26H9.259l2.963-3.705h7.222c.704 0 1.296-.592 1.296-1.296 0-.704-.592-1.296-1.296-1.296h-1.852c-2.74 0-5-2.26-5-5s2.26-5 5-5h9.815l-2.963 3.704h-6.852c-.704 0-1.296.592-1.296 1.296 0 .704.592 1.296 1.296 1.296h1.852c2.74 0 5 2.26 5 5s-2.26 5-5 5Z" fill="url(#paint2_linear_221_5669)" stroke="transparent"></path><path d="m33.732 3.185 1.518 4a.334.334 0 0 0 .222.222l4 1.519c.334.111.334.555 0 .704l-4 1.518a.334.334 0 0 0-.222.222l-1.518 4c-.112.334-.556.334-.704 0l-1.519-4a.334.334 0 0 0-.222-.222l-4-1.518c-.333-.112-.333-.556 0-.704l4.037-1.519a.334.334 0 0 0 .222-.222l1.519-4c.111-.296.555-.296.667 0Z" fill="url(#paint3_linear_221_5669)" stroke="transparent"></path><defs><linearGradient id="paint0_linear_221_5669" x1="4.968" y1="16.885" x2="11.42" y2="39.941" gradientUnits="userSpaceOnUse"><stop stop-color="#2F5AF5"></stop><stop offset="1" stop-color="#67E1F6"></stop></linearGradient><linearGradient id="paint1_linear_221_5669" x1="4.219" y1="2.407" x2="16.101" y2="30.135" gradientUnits="userSpaceOnUse"><stop stop-color="#2F5AF5"></stop><stop offset="1" stop-color="#67E1F6"></stop></linearGradient><linearGradient id="paint2_linear_221_5669" x1="10.806" y1="11.852" x2="18.836" y2="30.219" gradientUnits="userSpaceOnUse"><stop stop-color="#2F5AF5"></stop><stop offset="1" stop-color="#67E1F6"></stop></linearGradient><linearGradient id="paint3_linear_221_5669" x1="35.37" y1="2.963" x2="29.074" y2="15.556" gradientUnits="userSpaceOnUse"><stop stop-color="#FF6FF3"></stop><stop offset="1" stop-color="#A479FF"></stop></linearGradient></defs></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconStarTrekColor',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-star-trek-color`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
